export default __webpack_public_path__ + "static/media/windMeter.858494bd.jpg";